export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20with%20dramatic%20warm%20golden%20light%20beams%20radiating%20from%20center%20against%20deep%20dark%20background%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20haze%2C%20luxurious%20theater%20ambiance%2C%20amber%20and%20bronze%20highlights%2C%20velvet%20curtain%20texture%20hints%2C%20no%20text%2C%20no%20people%2C%20artistic%20cinematography%20style&width=1920&height=1080&seq=hero-bg-movie-01&orientation=landscape"
          alt="大师兄影视主题视觉"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-28 md:py-32">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/30 text-primary-400 text-sm font-medium mb-6">
              <i className="ri-fire-line"></i>
              全网热播 · 每日更新
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-50 leading-tight mb-4">
              大师兄影视 · 海量高清影视免费在线观看
            </h1>

            <p className="text-lg md:text-xl text-primary-400 font-heading mb-6">
              不缓冲 · 秒开播放 · 极速流畅
            </p>

            <div className="space-y-3 mb-8">
              <p className="text-foreground-300 leading-relaxed max-w-xl mx-auto lg:mx-0">
                大师兄影视汇聚<strong className="text-foreground-100">电视剧全集</strong>、<strong className="text-foreground-100">电影大全</strong>、<strong className="text-foreground-100">热门综艺</strong>与<strong className="text-foreground-100">经典影片</strong>，为您提供高清免费在线观看服务。片库每日持续更新，覆盖国内外热门剧集，真正做到不缓冲秒开播放，极速加载流畅观影体验。
              </p>
              <p className="text-foreground-400 leading-relaxed max-w-xl mx-auto lg:mx-0 text-sm">
                无论您想追最新热播剧、重温经典老片，还是发现冷门佳片，大师兄影视的海量片库都能一网打尽，随时随地畅享高品质观影。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">10000+</div>
                <div className="text-xs text-foreground-500 mt-1">海量片库</div>
              </div>
              <div className="w-px h-10 bg-background-300/50"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">200+</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新</div>
              </div>
              <div className="w-px h-10 bg-background-300/50"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">500万+</div>
                <div className="text-xs text-foreground-500 mt-1">活跃用户</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-base"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看
              </a>
              <a
                href="#app"
                onClick={(e) => { e.preventDefault(); document.querySelector('#app')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-8 py-3.5 border border-foreground-300/30 hover:border-primary-400/50 text-foreground-200 hover:text-primary-400 font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-base"
              >
                <i className="ri-smartphone-line text-lg"></i>
                下载客户端
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-3xl blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20projector%20casting%20warm%20golden%20light%20beam%20through%20darkness%2C%20floating%20film%20frames%20with%20abstract%20cinematic%20scenes%2C%20elegant%20movie%20poster%20composition%2C%20dramatic%20lighting%20with%20amber%20and%20bronze%20tones%2C%20artistic%20film%20aesthetic%2C%20no%20text%2C%20sophisticated%20cinema%20vibe&width=800&height=600&seq=hero-visual-movie-01&orientation=landscape"
                alt="大师兄影视主题主视觉 - 电影放映机与光影"
                className="w-full h-auto rounded-2xl relative z-10"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}